export { SentryMonitoringService } from './services/sentry-monitoring.service';

// Re-export Sentry webpack plugin for Next.js config
export { withSentryConfig } from '@sentry/nextjs';

// Export initialization functions for Sentry client and server
export { initializeSentryBrowserClient } from './sentry.client.config';
export { initializeSentryServerClient } from './sentry.server.config';

// The one `sentry_event_dropped` property mapping for `beforeSend` drops, shared
// by the browser, Node and Edge capture sites so their rows cannot drift apart
// (BAL-1020).
export { toIgnoredDropEventProperties } from './drop-telemetry';
export type { DropRuntime } from './drop-telemetry';

// Drop-sink payload contracts (BAL-856 `beforeSend`, BAL-959 `event_processor`).
// Exported so a CONSUMER's handler is checked against the real payload shape
// instead of a hand-written structural cast that drifts silently when a field
// is added — which is how a boolean sat in a `Record<string, string>` slot in
// the web app's own test of this sink.
export type {
  IgnoredDropInfo,
  IgnoredDropHandler,
  ProcessorDropInfo,
  ProcessorDropHandler,
  SinkArmedInfo,
  SinkArmedHandler,
} from './sentry.client.config';
